require('./styleAttributeMixin.js');

PegasusTemplate.PayloadMixin = Ember.Mixin.create( PegasusTemplate.StyleAttributeMixin, {
  classNames: ['payload'],
  attributeBindings: [
    'dataIsDisplayed:data-is-displayed'
  ],

  // This method makes sure that our `model attributes
  // automatically calculate their default values and connect
  // bindings to the respective BlockView.  Otherwise the attributes
  // that aren't actively used on a block don't calculate.
  forceWatchingComputation: function(){
    if ( ! this.get('parentView') ) { return; }

    var watching = Em.meta(this.get('parentView')).watching;
    var k, v;
    var reg = /^payload.data/;

    Object.keys(watching).forEach(function(key){
      if ( reg.test(key) ) {
        k = key.slice(8);
        if ( this.get('parentView.' + k ) ) { return; }

        v = this.get(k);
        this.set('parentView.' + k, v);
      }
    }.bind(this));
  },

  init: function(){
    this.forceWatchingComputation();
    this._super();
  }
});
